import { Page } from '@/core/architecture'

import { ResaleCreateConfirmationTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ResaleCreateConfirmation Page
 * Implemented as a practical sample.
 */
export const ResaleCreateConfirmation: Page = () => {
  const { state, actions } = useViewModel()

  return <ResaleCreateConfirmationTemplate state={state} {...actions} />
}
